import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section className="relative flex min-h-[620px] items-center justify-center overflow-hidden bg-background-100">
      <img
        src="https://readdy.ai/api/search-image?query=Colorful%20comic%20book%20manga%20panel%20collage%20with%20hero%20characters%2C%20speech%20bubbles%2C%20and%20dynamic%20action%20scenes%2C%20warm%20coral%20amber%20and%20cream%20palette%2C%20stylized%20artistic%20illustration%2C%20soft%20depth%2C%20vibrant%20yet%20cohesive%20color%20scheme%2C%20clean%20composition%20without%20text&width=1600&height=900&seq=home-hero&orientation=landscape"
        alt="漫画岛高清漫画阅读背景"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/40 to-black/55"></div>

      <div className="container-site relative z-10 w-full py-24 text-center md:py-32">
        <p className="mx-auto inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-1.5 text-xs text-white backdrop-blur-sm">
          <i className="ri-sparkling-2-fill text-accent-300"></i>
          全新阅读模式 · 高清原图 · 舒适追漫
        </p>
        <h1 className="mt-6 font-heading text-4xl leading-tight text-white md:text-6xl">
          漫画岛
        </h1>
        <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-white/90 md:text-lg">
          沉浸式阅读体验,阅读模式自由切换。横屏观看高清原图更震撼,夜间模式配合舒适翻页体验,长时间追漫不累眼,享受每一格画面。
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link
            to="/category/all"
            className="w-full whitespace-nowrap rounded-md bg-primary-500 px-8 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-400 sm:w-auto cursor-pointer"
          >
            开始阅读
          </Link>
          <Link
            to="/about"
            className="w-full whitespace-nowrap rounded-md border border-white/40 bg-white/10 px-8 py-3 text-sm font-semibold text-white backdrop-blur-sm transition-colors hover:bg-white/20 sm:w-auto cursor-pointer"
          >
            了解漫画岛
          </Link>
        </div>
      </div>
    </section>
  );
}